// extracted by mini-css-extract-plugin
module.exports = {"container":"Triple_container__0f8it"};